import { PageMeta } from "@/components/PageMeta";
import { PolicyLayout, type PolicySection } from "@/components/PolicyLayout";
import { siteConfig } from "@/config/site";
import { routeSeo } from "@/content/seo";

const sections: PolicySection[] = [
  { id: "summary", label: "1. Summary" },
  { id: "essential-storage", label: "2. Essential storage in use today" },
  { id: "no-optional-tracking", label: "3. No optional analytics or tracking today" },
  { id: "turnstile", label: "4. Cloudflare Turnstile" },
  { id: "future-changes", label: "5. If this changes" },
  { id: "browser-controls", label: "6. Your browser controls" },
  { id: "contact", label: "7. Contact" },
];

export function CookiesPage() {
  const seo = routeSeo["/legal/cookies"];
  return (
    <>
      <PageMeta title={seo.title} description={seo.description} path="/legal/cookies" />
      <PolicyLayout
        slug="cookies"
        title="Cookie Policy"
        intro="This policy explains what cookies and local storage this website actually uses today, no more and no less."
        sections={sections}
      >
        <h2 id="summary">1. Summary</h2>
        <p>
          This website does not set non-essential cookies and does not load optional analytics or
          advertising scripts. Because no optional tracking is used, there is no cookie consent
          banner: a banner offering to "accept" or "reject" tracking that doesn't exist would be
          misleading.
        </p>

        <h2 id="essential-storage">2. Essential storage in use today</h2>
        <p>
          Cloudflare, which hosts and secures this website, may use strictly necessary mechanisms
          (such as security and routing cookies) to deliver the site and protect it from abuse.
          These are essential to operating the website and are not used to track you across other
          sites.
        </p>

        <h2 id="no-optional-tracking">3. No optional analytics or tracking today</h2>
        <p>
          This website does not currently run a web analytics script, advertising pixel, or
          third-party tracking script of any kind.
        </p>

        <h2 id="turnstile">4. Cloudflare Turnstile</h2>
        <p>
          The contact form is built to support Cloudflare Turnstile, a privacy-preserving
          bot-detection challenge, as an anti-abuse measure. Turnstile is not currently active on
          this deployment; if and when it is enabled, it will run only on the contact form to
          confirm you are not an automated bot, and this section will be updated to reflect that.
        </p>

        <h2 id="future-changes">5. If this changes</h2>
        <p>
          If Devory later adds optional analytics or other non-essential tracking, this policy will
          be updated first, and, where required, a consent mechanism will be added before any such
          tracking loads, with the ability to withdraw consent at any time.
        </p>

        <h2 id="browser-controls">6. Your browser controls</h2>
        <p>
          You can control or clear cookies and local storage through your browser's own settings at
          any time. Doing so may affect essential site functionality provided by Cloudflare.
        </p>

        <h2 id="contact">7. Contact</h2>
        <p>
          Questions about this policy can be sent to{" "}
          <a href={`mailto:${siteConfig.contactEmail}`}>{siteConfig.contactEmail}</a>.
        </p>
      </PolicyLayout>
    </>
  );
}
